import { render, staticRenderFns } from "./TicketHistoricoTab.vue?vue&type=template&id=8c64ee56&"
import script from "./TicketHistoricoTab.vue?vue&type=script&lang=js&"
export * from "./TicketHistoricoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports